import styled from "styled-components"
import { Container } from "@mui/material"

export const Wrapper = styled.footer``

export const InnerWrapper = styled(Container)`
  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 0 4em;
  }
`

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: rgba(25, 27, 29, 0.5) 1px solid;
  padding-top: 2em;
  padding-bottom: 2em;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    display: flex;
    flex-direction: column;
  }

  .left,
  .right {
    ${({ theme }) => theme.breakpoints.down("sm")} {
      margin: auto;
    }
  }

  .left,
  .middle {
    text-align: center;
  }

  .left {
    ${({ theme }) => theme.breakpoints.up("md")} {
      width: 150px;
    }
  }

  .middle {
    ${({ theme }) => theme.breakpoints.up("md")} {
      width: calc(100% - 310px);
      padding: 0 4em;
    }
  }

  .right {
    text-align: right;

    ${({ theme }) => theme.breakpoints.up("md")} {
      width: 160px;
    }
  }

  .booking {
    text-transform: uppercase;
    text-decoration: none;
    margin-bottom: 0;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    color: #191b1d;
    opacity: 0.5;

    ${({ theme }) => theme.breakpoints.down("sm")} {
      font-size: ${({ theme }) => theme.typography.pxToRem(12)};
    }
  }

  .phone {
    color: #000000;
    text-decoration: none;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};

    ${({ theme }) => theme.breakpoints.down("sm")} {
      font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    }
  }

  .address {
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 0;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};

    ${({ theme }) => theme.breakpoints.down("sm")} {
      font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    }
  }
`

export const Disclaimer = styled.p`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
`
